import { render } from "./AddEditProject.vue?vue&type=template&id=57914b83&scoped=true"
import script from "./AddEditProject.vue?vue&type=script&lang=js"
export * from "./AddEditProject.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css&external"
import "./AddEditProject.vue?vue&type=style&index=1&id=57914b83&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57914b83"]])

export default __exports__